import React from 'react'
import { Bleed, Card, colors, FlowGrid, H2, Image, Paragraph, Separator, usePageWidth } from '@fs/zion-ui'

export default function ExperienceCard({
  centered = true,
  children,
  heading,
  headingProps,
  horizontal,
  horizontalReversed = false,
  image,
  imageBleedProps = { bottom: true },
  imageProps = {},
  subheading,
  ...props
}) {
  const isMobile = usePageWidth()({ default: true, xl: false })
  const shouldReverse = horizontal && horizontalReversed
  const Content = horizontal ? FlowGrid : 'div'
  const contentProps = horizontal
    ? { columnCount: 2, gutters: 'xl' }
    : { style: { display: 'flex', justifyContent: 'space-between', flexDirection: 'column', height: '100%' } }

  const leftColumn = (
    <div {...(horizontal ? { alignY: 'middle', style: { paddingInlineEnd: '64px' } } : {})}>
      <H2 balanced centered={!horizontal && centered} size="H3" supplementary {...headingProps}>
        {heading}
      </H2>
      <Separator size="xs" />
      <Paragraph balanced centered={!horizontal && centered}>
        {subheading}
      </Paragraph>
      {children}
    </div>
  )

  const rightColumn = image ? (
    <>
      {!horizontal && <Separator size="sm" />}
      <Bleed {...imageBleedProps}>
        <Image alt="" src={image} {...imageProps} />
      </Bleed>
    </>
  ) : null

  return (
    <Card backgroundColor={colors.gray00} edges="none" margins={isMobile ? 'md' : 'lg'} {...props}>
      <Content {...contentProps}>
        {shouldReverse ? rightColumn : leftColumn}
        {shouldReverse ? leftColumn : rightColumn}
      </Content>
    </Card>
  )
}
